export const DEFAULT_EVENT_VALUE = 'NA';

export const ANALYTICS_DATA_TAGS: Record<string, number> = {
	orderId: 1,
};

export const PAGE_EVENTS = {
	PAGE_LOADED: 'PAGE_LOADED',
} as const;

export const FETCH_API_EVENTS = {
	FETCH_PAGE_DETAILS_INIT: 'FETCH_PAGE_DETAILS_INIT',
	FETCH_PAGE_DETAILS_SUCCESS: 'FETCH_PAGE_DETAILS_SUCCESS',
	FETCH_PAGE_DETAILS_FAILED: 'FETCH_PAGE_DETAILS_FAILED',
	BRAND_LOGO_FETCH_FAILED: 'BRAND_LOGO_FETCH_FAILED',
} as const;

/** API Events - Submit Payment Page Data */
export const SUBMIT_API_EVENTS = {
	SUBMIT_PAYMENT_DATA_INIT: 'SUBMIT_PAYMENT_DATA_INIT',
	SUBMIT_PAYMENT_DATA_SUCCESS: 'SUBMIT_PAYMENT_DATA_SUCCESS',
	SUBMIT_PAYMENT_DATA_FAILED: 'SUBMIT_PAYMENT_DATA_FAILED',
} as const;

export const ACTION_EVENTS = {
	VERIFY_BUTTON_CLICKED: 'VERIFY_BUTTON_CLICKED',
	PROCEED_BUTTON_CLICKED: 'PROCEED_BUTTON_CLICKED',
	FORM_VALIDATION_FAILED: 'FORM_VALIDATION_FAILED',
} as const;

export const Event = {
	...PAGE_EVENTS,
	...FETCH_API_EVENTS,
	...SUBMIT_API_EVENTS,
	...ACTION_EVENTS,
} as const;
